import {
  Box,
  Button,
  Card,
  createStyles,
  Grid,
  Text,
  Title,
  UnstyledButton,
  useMantineTheme
} from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconDoorEnter } from '@tabler/icons'
import Image from 'next/image'
import Link from 'next/link'

interface Props {
  title: string
  description?: string
  detail?: string
  slug: string
  image?: string
}

const useStyles = createStyles(theme => ({
  card: {
    [theme.fn.smallerThan('xs')]: { display: 'flex' },
    [theme.fn.smallerThan(350)]: { display: 'inherit' }
  },
  cardImageWrapper: {
    [theme.fn.smallerThan('xs')]: { minWidth: '130px', width: '50vw' },
    [theme.fn.smallerThan(350)]: { width: '100%' }
  },
  imageWrapper: {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%',
    aspectRatio: '16/9',
    backgroundColor: theme.colors[theme.primaryColor][0],
    [theme.fn.smallerThan('xs')]: { height: '100%' }
  },
  detailDisplay: {
    padding: 4,
    backgroundColor: theme.colors.gray[0]
  }
}))

export default function PageCard({ title, description, detail, slug, image }: Props) {
  // Hooks
  const { classes } = useStyles()
  const theme = useMantineTheme()
  const isXs = useMediaQuery(`(max-width: ${theme.breakpoints.xs}px)`)

  // Constants
  const currentPath = window?.location?.pathname || '/'
  const showcaseUrl = `${currentPath}/${slug}`

  return (
    <Card withBorder p={0} className={classes.card}>
      <Card.Section className={classes.cardImageWrapper}>
        <Box className={classes.imageWrapper}>
          <UnstyledButton component={Link} href={showcaseUrl} sx={{ height: '100%' }}>
            <Image
              src={image || '/images/placeholders/store.png'}
              alt={title}
              fill
              quality={60}
              style={{ objectFit: 'cover' }}
            />
          </UnstyledButton>
        </Box>
        <Box className={classes.detailDisplay} hidden={!detail}>
          <Text size="xs" color="dimmed" align="right" mr="xs">
            {detail}
          </Text>
        </Box>
      </Card.Section>
      <Grid p="sm" justify="center" align="center" grow>
        <Grid.Col span={9} xs={12}>
          <Title order={isXs ? 4 : 5}>{title}</Title>
        </Grid.Col>
        <Grid.Col span={3} xs={12}>
          <Button
            component={Link}
            href={showcaseUrl}
            fullWidth
            rightIcon={<IconDoorEnter size={16} />}>
            Ver Produtos
          </Button>
        </Grid.Col>
      </Grid>
    </Card>
  )
}
